<template>
  <v-row dense>
    <v-col cols="12">
      <v-checkbox
        v-model="form.is_additional_notify"
        name="is_additional_notify"
        :label="$t('FORMS.NOTIFY_SENDING')"
        :error="errors.is_additional_notify"
      ></v-checkbox>
    </v-col>
    <v-col cols="12">
      <v-combobox
        v-model="form.emails"
        chips
        clearable
        :label="$t('ITEM.EMAILS')"
        multiple
        outlined
        :rules="rules.email"
        :error-messages="errors.emails"
        @change="updateValue('emails', $event)"
      >
        <template v-slot:selection="{ attrs, item, select, selected }">
          <v-chip
            v-bind="attrs"
            :input-value="selected"
            close
            @click="select"
            @click:close="remove(item)"
          >
            <strong>{{ item }}</strong>
          </v-chip>
        </template>
      </v-combobox>
    </v-col>
  </v-row>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import {
  emails,
  requiredSelectArray
} from '@/modules/_global/variables/rules.js';
export default {
  name: 'EmailsForm',

  mixins: [formEditable],

  data() {
    return {
      form: {
        is_additional_notify: false,
        emails: []
      }
    };
  },

  computed: {
    rules() {
      return {
        email: this.form.is_additional_notify
          ? requiredSelectArray && emails
          : this.form.emails.length
          ? emails
          : []
      };
    }
  },

  methods: {
    remove(item) {
      this.form.emails.splice(this.form.emails.indexOf(item), 1);
    }
  }
};
</script>

<style scoped></style>
